import React, { useEffect, useState } from 'react';
// Use useHistory for React Router v5
import { useHistory } from 'react-router-dom';
import { loadNotifications, deleteNotification } from '../../../api/notifications';
import { ROUTES } from "../../../config/routes";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable from 'react-data-table-component';
import { Modal, Button } from 'react-bootstrap';

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await loadNotifications();
        setNotifications(data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

    
    const formatDate = (date) => {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    return new Date(date).toLocaleDateString('fr-FR', options);
    
};

  const handleBack = () => {
    history.push(ROUTES.DASHBOARD.path); 
    window.scrollTo(0, 0);
  };

  const handleEdit = (id) => {
    history.push(`${ROUTES.CREATE_NOTIFICATION.path}?nid=${id}`);
    window.scrollTo(0, 0);
  };

  const handleDeleteClick = (id) => {
    setNotificationToDelete(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await deleteNotification(notificationToDelete);
      setNotifications(notifications.filter(n => n.id !== notificationToDelete));
      toast.success("Notification deleted successfully");
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting notification:", error);
      toast.error("Failed to delete notification");
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setNotificationToDelete(null);
  };

  const handleCreate = () => {
    history.push(ROUTES.CREATE_NOTIFICATION.path);
  } 

  const columns = [
    { name: 'Title', selector: row => row.title, sortable: true },
    {
      name: 'Begin Date',
      selector: row =>  formatDate(new Date(row.beginDate)),
    },
    {
      name: 'End Date',
      selector: row => row.endDate?.seconds 
        ? formatDate(new Date(row.endDate.seconds * 1000))
        : formatDate(new Date(row.endDate)),
    },
    { name: 'Content', selector: row => row.content, wrap: true },
    {
      name: 'Actions',
      cell: row => (
        <div className="submit-btn action-buttons" style={{ marginBottom: "1rem", minWidth: "150px" }}>
          <button className="btn btn-primary btn-action" onClick={() => handleEdit(row.id)} title="Editer">
            <i className="bi bi-pencil"></i>
          </button>
          <button className="btn btn-danger btn-action" onClick={() => handleDeleteClick(row.id)} title="Supprimer">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold'
      }
    }
  };

  return (
    <div className="contact-wrapper overflow-hidden">
      <ToastContainer />
      <div className="container pt-120 position-relative">
        <div className="row">
          <div className="col-lg-8"></div>
          <div className="articles-container">
            <h1>Notifications</h1>
            <button className="mb-4 mt-4 btn btn-primary" onClick={handleCreate}>
              <i className="bi bi-plus" title="Créer une notification"></i>
            </button>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <DataTable
                columns={columns}
                data={notifications}
                pagination
                highlightOnHover
                responsive
                striped
                dense
                customStyles={customStyles}
              />
            )}
            <div className="submit-btn">
              <button type="button" onClick={handleBack} className="btn btn-secondary">
                <i className="bi bi-arrow-left" title="Retour au dashboard"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showDeleteModal} onHide={handleDeleteCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation de suppression</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr de vouloir supprimer cette notification ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCancel}>
            Abandonner
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NotificationsPage;
